"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableInput = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _faPencilAlt = require("@fortawesome/free-solid-svg-icons/faPencilAlt");
var _clsx = _interopRequireDefault(require("clsx"));
var _Checkbox = require("../../Checkbox");
var _EditableInputDropdown = require("../../Dropdown/EditableInputDropdown");
var _Select = require("../../Select");
var _Tooltip = require("../../Tooltip");
var _button = require("../../button");
var _EditableInput = require("./EditableInput.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var EditableInput = function EditableInput(_ref) {
  var value = _ref.value,
    characterLength = _ref.characterLength,
    editable = _ref.editable,
    onEdit = _ref.onEdit,
    detailsModal = _ref.detailsModal,
    coreInfo = _ref.coreInfo,
    parentRef = _ref.parentRef,
    _onBlur = _ref.onBlur,
    name = _ref.name,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? '13px' : _ref$fontSize,
    options = _ref.options,
    multiSelect = _ref.multiSelect,
    editableState = _ref.editableState,
    radioButton = _ref.radioButton,
    largeField = _ref.largeField,
    textPersist = _ref.textPersist,
    placeHolder = _ref.placeHolder,
    _ref$multiAutoComplet = _ref.multiAutoCompleteWidth,
    multiAutoCompleteWidth = _ref$multiAutoComplet === void 0 ? '100px' : _ref$multiAutoComplet,
    number = _ref.number,
    _ref$bulletpointThres = _ref.bulletpointThreshold,
    bulletpointThreshold = _ref$bulletpointThres === void 0 ? 5 : _ref$bulletpointThres;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showInput = _useState2[0],
    setShowInput = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    touched = _useState4[0],
    setTouched = _useState4[1];
  var classes = (0, _EditableInput.useStyles)({
    detailsModal: detailsModal,
    largeField: largeField,
    textPersist: textPersist,
    multiAutoCompleteWidth: multiAutoCompleteWidth
  });
  var handleEdit = function handleEdit(e) {
    if (parentRef !== null && parentRef !== void 0 && parentRef.current && e) {
      parentRef.current.value = e.target.value;
    }
    if (onEdit && e) {
      onEdit(e.target.value);
    }
  };
  var formatList = function formatList(selectedValues, bulletpointThreshold) {
    if (selectedValues.length > bulletpointThreshold) {
      return /*#__PURE__*/_react["default"].createElement(_Tooltip.APTooltip, {
        placement: "bottom",
        arrow: true,
        title: /*#__PURE__*/_react["default"].createElement("ul", {
          style: {
            marginLeft: '-24px'
          }
        }, selectedValues.map(function (r) {
          return /*#__PURE__*/_react["default"].createElement("li", null, r.label);
        }))
      }, /*#__PURE__*/_react["default"].createElement("span", null, selectedValues.map(function (r) {
        return r.label;
      }).slice(0, bulletpointThreshold).join(', '), ", ..."));
    } else {
      return selectedValues.map(function (r) {
        return r.label;
      }).join(', ') || '-';
    }
  };
  (0, _react.useEffect)(function () {
    setShowInput(editableState || false);
  }, [editableState]);
  var formatText = function formatText(text, number) {
    var output = text;
    if (number) {
      output = Number(output).toLocaleString('en-US');
    }
    if (text === '' || !text) {
      return '-';
    }
    if (typeof value === 'string' && (value === null || value === void 0 ? void 0 : value.length) > characterLength) {
      output = /*#__PURE__*/_react["default"].createElement(_Tooltip.APTooltip, {
        placement: "bottom",
        arrow: true,
        title: /*#__PURE__*/_react["default"].createElement("p", {
          style: {
            whiteSpace: 'break-spaces'
          }
        }, value)
      }, /*#__PURE__*/_react["default"].createElement("span", null, value.substring(0, characterLength), "..."));
    }
    return output;
  };
  var inputField = /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    value: textPersist ? value : null,
    className: (0, _clsx["default"])("UiInput ".concat(classes.root, " ").concat(name), classes.textField),
    inputRef: parentRef,
    multiline: largeField,
    variant: "filled",
    inputProps: {
      style: {
        resize: 'both',
        minHeight: largeField ? '185px' : undefined
      }
    },
    placeholder: placeHolder || '',
    onChange: handleEdit,
    onBlur: function onBlur(e) {
      if (_onBlur) {
        _onBlur(e);
      }
      setTouched(true);
    },
    type: number ? 'number' : undefined,
    onWheel: number ? function (e) {
      return e.target.blur();
    } : undefined,
    name: name,
    style: {
      fontSize: "".concat(fontSize)
    }
  });
  if (options) {
    if (!multiSelect) {
      inputField = /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.containerDiv
      }, /*#__PURE__*/_react["default"].createElement(_EditableInputDropdown.EditableInputDropdown, {
        parentRef: parentRef,
        className: classes.dropdown,
        handleChange: handleEdit,
        name: name,
        placeholder: placeHolder,
        textPersist: textPersist,
        value: textPersist ? value : undefined
      }, options.map(function (field) {
        return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          value: field
        }, field.toString());
      })));
    } else {
      inputField = /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.containerDiv
      }, /*#__PURE__*/_react["default"].createElement(_Select.MultiAutoCompleteSelect, {
        options: options,
        variant: "outlined",
        id: "autocomplete-field",
        "data-testid": "autocomplete-field",
        getOptionSelected: function getOptionSelected(option, value) {
          return option.value === value.value;
        },
        value: value,
        placeholder: placeHolder,
        onChange: function onChange(e, value) {
          return onEdit ? onEdit(value) : undefined;
        },
        className: classes.autocomplete
      }));
    }
  }
  if (radioButton) {
    inputField = /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
      checked: !!value,
      color: "primary",
      onChange: onEdit,
      testId: "checkbox"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: "editableInput",
    fontSize: fontSize,
    fontWeight: "300",
    lineHeight: "27px",
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, editable ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showInput ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, inputField) : editableState !== undefined ? /*#__PURE__*/_react["default"].createElement("div", null, multiSelect ? formatList(value, bulletpointThreshold) : radioButton ? /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    checked: !!value,
    color: "primary",
    onChange: onEdit,
    testId: "checkbox",
    disabled: true
  }) : formatText(value ? value.toString() : '', number)) : /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: touched ? '#CF752F' : '#212529'
    }
  }, multiSelect ? value.map(function (r) {
    return r.label;
  }).join(', ') || '-' : formatText(value ? value.toString() : '', number)), editableState !== null && editableState !== void 0 ? editableState : /*#__PURE__*/_react["default"].createElement(_button.IconButton, {
    color: "default",
    icon: _faPencilAlt.faPencilAlt,
    "data-testid": "pencil-icon",
    style: {
      fontSize: "".concat(fontSize),
      position: 'relative',
      right: '-6px',
      padding: '6px',
      marginLeft: '-2px'
    },
    onClick: function onClick() {
      return setShowInput(!showInput);
    }
  })) : editableState !== undefined ? /*#__PURE__*/_react["default"].createElement("div", null, formatText(value ? value.toString() : '', number)) : /*#__PURE__*/_react["default"].createElement("p", {
    style: coreInfo ? {
      color: 'black'
    } : {
      color: '#21252999'
    }
  }, formatText(value, number)));
};
exports.EditableInput = EditableInput;